<div class="bg-col-w"
     (offClick)="close()"
     [offClickFilter]="'photoswipe-lightbox'">

    <button class="p-a pos-absolute top-4 right-0"
            type="button"
            [attr.aria-label]="'Close' | translate"
            (click)="close()">
        <i class="icon-close"
           [style.line-height.px]="0"
           aria-hidden="true"></i>
    </button>

    <div class=" w-12 p-a-8 p-a-4-m p-a-4-s b-b b-col-53">
        <div class="flex flex-middle">
            <img [image]="'/assets/images/revio-logo.svg'"
                 class="_feefo-image">
            <div class="h1 m-l-5 flex-grow">{{'Reviews' | translate}}</div>
        </div>
        <div class="m-t-6 m-t-4-m m-t-4-s flex flex-middle flex-wrap">
            <span class="h4 m-r-2 m-r-4-m m-r-4-s"
                  style="line-height: 1em;">{{productsData.rating}}</span>
            <rating class="inline-flex fs-9-x fs-9-l"
                    [value]="productsData.rating"></rating>
            <span class="m-l m-r"
                  style="line-height: 1em;"
                  sizeClass="XL:p1, MS:p2">({{productsData.count}})</span>

            <div class="flex-grow"></div>

            <!-- sort by -->
            <div class="flex flex-middle w-12-s w-12-m m-t-4-s m-t-4-m">
                <span class="col-11 p1 m-r-2 no-wrap">{{'Sort' | translate}}:</span>
                <div class="pos-relative"
                     (offClick)="toggleSortOpen()"
                     [offClickOff]="!sortOpen">
                    <div (click)="toggleSortOpen(!sortOpen)"
                         class="_sortLabel p-a-2 bg-col-51 cursor-pointer flex flex-middle flex-justify-between">
                        <p class="col-11"
                           sizeClass="SM: p2, XL: p1">{{selectedSortOption.name}}</p>
                        <i [ngClass]="sortOpen ? '_isUp' : '_isDown'"
                           class="icon-chevron icon-medium inline-flex"></i>
                    </div>
                    <div class="hide-up-container pos-absolute z-2 top-100 right-0 w-12 m-t-1 _sortOptions">
                        <div [class.ng-hide]="!sortOpen"
                             class="hide-up ng-hide ng-hide-animate bg-col-w p-a-1 left">
                            @for (option of sortOptions; track $index; let isLast = $last) {
                            @if (option.name !== selectedSortOption.name) {
                            <div class="bg-col-51 p-a-1 p-l-2 cursor-pointer _sortOptionLabel"
                                 [class.m-b-1]="!isLast"
                                 (click)="sortReviews(option)">
                                <span class="col-11"
                                      sizeClass="SM: p2, XL: p1">{{option.name}}</span>
                            </div>
                            }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <product-reviews class="_reviews-container p-a-4-m p-a-4-s"
                     [product]="productsData.product.extendedFamilyIds"
                     [parent]="productsData.product.parent"
                     [sortOption]="selectedSortOption"
                     [variant]="'modal'"></product-reviews>
</div>